import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CardGroup, Col, Container, Row } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { chgTokenApiGraph } from "../../redux/ReduxToken";
import ComponentBandeau from "../../components/layout/ComponentBandeau";
import ComponentLoader from "../../components/layout/ComponentLoader";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentSousTitle from "../../components/layout/ComponentSousTitle";
import { apiGetSpaces } from "../../api/ApiSpace";
import ComponentEspace from "../../components/public/space/ComponentEspace";
import BlocFiltresEspaces from "../../components/public/space/BlocFiltresEspaces";
import ComponentEspaceInfo from "../../components/public/space/ComponentEspaceInfo";
import { apiGetCalendrierSalles } from "../../api/ApiGraph";
import BlocToggle from "../../components/layout/ComponentToggle";

import { chgSpaceToggle, selectSpaceToggle } from "../../redux/ReduxToggle";
import ComponentCalendrierGlobal from "../../components/public/space/ComponentCalendrierGlobal";
import { apiGetUsages } from "../../api/ApiUsage";
import BlocChoixUtiliser from "../../components/public/space/BlocChoixUtiliser";
import { selectUtiliserFilters } from "../../redux/ReduxFilter";
import { apiGetMobilities } from "../../api/ApiMobilities";
import ComponentMobility from "../../components/public/space/ComponentMobility";
import BlocFiltreMobilities from "../../components/public/space/BlocFiltreMobilities";
import ComponentMobilityInfo from "../../components/public/space/ComponentMobilityInfo";

const PageEspaces = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxRefresh } = useSelector((state) => state.ReduxRefresh);
  const { ReduxTokenApiGraph } = useSelector((state) => state.ReduxToken);
  const _selectUtiliserFilters = useSelector(selectUtiliserFilters);
  const [loader, setLoader] = useState(true);
  const [loaderCalendrier, setLoaderCalendrier] = useState(false);
  const [spaces, setSpaces] = useState([]);
  const [calendriers, setCalendriers] = useState([]);
  const [filterSpaces, setFilterSpaces] = useState([]);
  const [filtreUsagesActif, setFiltreUsagesActif] = useState(false);
  const [filtreUsagesDigitalActif, setFiltreUsagesDigitalActif] = useState(false);
  const [tabKey, setTabKey] = useState("informations");
  const [debutFormat, setDebutFormat] = useState();
  const [finFormat, setFinFormat] = useState();
  const [refreshDemande, setRefreshDemande] = useState(false);
  const [usages, setUsages] = useState([]);

  const [mobilities, setMobilities] = useState([]);
  const [filterMobilities, setFilterMobilities] = useState([]);
  const [infoView, setInfoView] = useState(false);
  const [infoViewMobility, setInfoViewMobility] = useState(false);
  const [tabKeyMobility, setTabKeyMobility] = useState("informations");

  const [anteriorite, setAnteriorite] = useState(31);
  const [viewToggle, setViewToggle] = useState(useSelector(selectSpaceToggle));

  const switchView = () => {
    dispatch(chgSpaceToggle(!viewToggle));
    setViewToggle(!viewToggle);
  };

  const recupCalendriers = async (espaces) => {
    setLoaderCalendrier(true);
    // si l'instance permet de récupérer les calendriers des salles
    let debut = new Date();
    debut = debut.toLocaleDateString("fr");
    let decoupageDebut = debut.split("/");
    let debutFormat = decoupageDebut[2] + "-" + decoupageDebut[1] + "-" + decoupageDebut[0];

    // calcul pour prendre la semaine en cours + 3 semaines derriere jusqu'au vendredi
    let fin = new Date();
    fin = fin.setUTCDate(fin.getUTCDate() - fin.getUTCDay() + 33);
    fin = new Date(fin);
    fin = fin.toLocaleDateString("fr");
    let decoupageFin = fin.split("/");
    let finFormat = decoupageFin[2] + "-" + decoupageFin[1] + "-" + decoupageFin[0];

    // on va récupérer les agendas de salles si au moins une salle a une adresse mail
    const sallesAvecEmail = espaces.filter((item) => item.email);
    if (sallesAvecEmail.length) {
      let formdata = new FormData();
      formdata.append("instance", ReduxInstance._id);
      formdata.append("vue", "salle");
      for (var i = 0; i < sallesAvecEmail.length; i++) {
        formdata.append("salles[]", sallesAvecEmail[i].email);
      }

      formdata.append("dateDebut", debutFormat);
      formdata.append("dateFin", finFormat);

      //formdata.append("dateDebut", "2023-06-26");
      //formdata.append("dateFin", "2023-06-30");

      const resCalendriers = await apiGetCalendrierSalles(ReduxTokenApiGraph, formdata);
      if (resCalendriers.data) {
        dispatch(chgTokenApiGraph(resCalendriers.data.token));
        setCalendriers(resCalendriers.data.data);
        setDebutFormat(debutFormat);
        setFinFormat(finFormat);
        // si un calendrier existe alors on met cette vue par defaut à l'arrivée sur la page
        dispatch(chgSpaceToggle(true));
        setViewToggle(true);
      } else {
        dispatch(chgSpaceToggle(false));
        setViewToggle(false);
      }
    }
    setLoaderCalendrier(false);
  };

  const recupEspaces = async () => {
    const resSpaces = await apiGetSpaces(ReduxInstance._id, "include=localisation&sort=mainUse");
    if (resSpaces.data) {
      setSpaces(resSpaces.data);
      setFilterSpaces(resSpaces.data.sort((a, b) => (a.nom > b.nom ? 1 : b.nom > a.nom ? -1 : 0)));
      if (ReduxInstance.calendrier) {
        recupCalendriers(resSpaces.data);
      } else {
        if (viewToggle) switchView();
      }
    }
    setLoader(false);
  };

  const recupMobilites = async () => {
    const resMobilities = await apiGetMobilities(
      ReduxInstance._id,
      "include=localisation&sort=mainUse"
    );
    if (resMobilities.data) {
      setMobilities(resMobilities.data);
      setFilterMobilities(
        resMobilities.data.sort((a, b) => (a.nom > b.nom ? 1 : b.nom > a.nom ? -1 : 0))
      );
    }
    setLoader(false);
  };

  const calendrierFiltre = (email) => {
    if (email && ReduxInstance.calendrier) {
      const calendrierDeLaSalle = calendriers.filter((item) => item.salleAdress === email);
      if (calendrierDeLaSalle.length === 1) {
        return calendrierDeLaSalle[0].agendaSalle;
      }
    }
    return null;
  };

  useEffect(() => {
    recupEspaces();
    recupUsages();
    recupMobilites();
  }, [ReduxInstance, ReduxRefresh]); // eslint-disable-line react-hooks/exhaustive-deps

  const recupUsages = async () => {
    const resUsages = await apiGetUsages(ReduxInstance._id);
    setUsages(resUsages.data);
  };

  return (
    <>
      <ComponentMenu menuActif="espaces" />
      <div className="containerHeaderBandeau">
        <ComponentBandeau menu="espaces" isCalendarView={viewToggle} />
        {ReduxInstance.calendrier && (
          <>
            {loaderCalendrier && (
              <div
                className="containerToggleChrono text-center"
                style={{ background: "white", zIndex: 2 }}
              >
                <ComponentLoader />
              </div>
            )}
            {calendriers.length !== 0 && (
              <BlocToggle
                viewToggle={viewToggle}
                switchView={switchView}
                setAnteriorite={setAnteriorite}
                anteriorite={anteriorite}
                curseurInitial={1}
                max={4}
                min={-1}
                afficheGraduation={false}
                pageConcernee="utiliser"
                sousMenus={ReduxInstance.sousMenus.filter((item) => item.parent === "espaces")}
              />
            )}
          </>
        )}
      </div>

      {loader && (
        <div className="text-center">
          <ComponentLoader />
        </div>
      )}

      {viewToggle && !loader && (
        <Container fluid className="mt-3">
          <ComponentSousTitle nom={t("public.filtres.filtre18")} />

          <BlocFiltresEspaces
            spaces={spaces}
            setFilterSpaces={setFilterSpaces}
            setFiltreUsagesActif={setFiltreUsagesActif}
            setFiltreUsagesDigitalActif={setFiltreUsagesDigitalActif}
            infoView={infoView}
            setInfoView={setInfoView}
          />

          {ReduxInstance.calendrier && (
            <ComponentCalendrierGlobal
              calendriers={calendriers}
              sallesAvecEmail={filterSpaces.filter((item) => item.email)}
              debutCalendrier={debutFormat}
              finCalendrier={finFormat}
              usagesDiponibles={usages}
            />
          )}
        </Container>
      )}

      {!viewToggle && (
        <>
          {!loader && (
            <>
              <BlocChoixUtiliser ReduxInstance={ReduxInstance} />

              {(_selectUtiliserFilters.espace || _selectUtiliserFilters.all) && (
                <Container fluid className="mt-3">
                  <ComponentSousTitle
                    nom={t("public.filtres.filtre17")}
                    overflowID={!infoView ? "overflowEspaces" : ""}
                  />
                  <BlocFiltresEspaces
                    spaces={spaces}
                    setFilterSpaces={setFilterSpaces}
                    setFiltreUsagesActif={setFiltreUsagesActif}
                    setFiltreUsagesDigitalActif={setFiltreUsagesDigitalActif}
                    infoView={infoView}
                    setInfoView={setInfoView}
                  />
                  {!infoView && (
                    <CardGroup className="disableOverflowContent" id={"overflowEspaces"}>
                      {filterSpaces.map((espace, index) => (
                        <ComponentEspace
                          espace={espace}
                          key={index}
                          filtreUsagesActif={filtreUsagesActif}
                          calendrier={calendrierFiltre(espace.email)}
                          usagesDiponibles={usages}
                        />
                      ))}
                    </CardGroup>
                  )}
                  {infoView && (
                    <Row>
                      {filterSpaces.map((espace, index) => (
                        <Col style={{ marginTop: 8 }} key={index} xs={12} sm={12} md={12} lg={6}>
                          <ComponentEspaceInfo
                            espace={espace}
                            key={index}
                            tabKey={tabKey}
                            setTabKey={setTabKey}
                            ongletCalendrier={ReduxInstance.calendrier}
                            calendriers={calendriers}
                            usagesDisponibles={usages}
                          />
                        </Col>
                      ))}
                    </Row>
                  )}
                </Container>
              )}
              {(_selectUtiliserFilters.mobilite || _selectUtiliserFilters.all) && (
                <Container fluid className="mt-3">
                  <ComponentSousTitle
                    nom={t("public.filtres.filtre20")}
                    overflowID={!infoViewMobility ? "overflowMobilites" : ""}
                  />
                  <BlocFiltreMobilities
                    mobilities={mobilities}
                    setFilterMobilities={setFilterMobilities}
                    infoViewMobility={infoViewMobility}
                    setInfoViewMobility={setInfoViewMobility}
                  />
                  {!infoViewMobility && (
                    <CardGroup className="disableOverflowContent" id={"overflowMobilites"}>
                      {filterMobilities.map((mobility, index) => (
                        <ComponentMobility mobility={mobility} key={index} />
                      ))}
                    </CardGroup>
                  )}
                  {infoViewMobility && (
                    <Row>
                      {filterMobilities.map((mobility, index) => (
                        <Col style={{ marginTop: 8 }} key={index} xs={12} sm={12} md={12} lg={6}>
                          <ComponentMobilityInfo
                            mobility={mobility}
                            key={index}
                            tabKeyMobility={tabKeyMobility}
                            setTabKeyMobility={setTabKeyMobility}
                          />
                        </Col>
                      ))}
                    </Row>
                  )}
                </Container>
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default PageEspaces;
